import { useLogoutMutation } from 'redux/auth/authApiSlice';
import { setCredentials, unsetCredentials } from 'redux/auth/authSlice';
import { useAppDispatch } from 'redux/hooks';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import useConfig from 'Hooks/useConfig';

export default function useAuth() {
  const { config } = useConfig();
  const dispatch = useAppDispatch();
  const [logoutMutation] = useLogoutMutation();

  const {
    logout: auth0Logout,
    getAccessTokenSilently,
    isLoading,
    isAuthenticated,
    error: authError
  } = useAuth0();

  const handleLogout = async () => {
    try {
      await logoutMutation().unwrap();
      dispatch(unsetCredentials());

      await auth0Logout({
        logoutParams: {
          returnTo: window.location.origin,
          client_id: config.auth0CMSClientId
        }
      });
    } catch (error) {
      console.error('Logout error:', error);
      window.location.href = '/login';
    }
  };

  const handleTokenRefresh = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      dispatch(setCredentials({ accessToken, expires: null }));
      return accessToken;
    } catch (error) {
      await handleLogout();
      return null;
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      handleTokenRefresh();
    }
  }, [isAuthenticated]);

  return {
    isLoggedIn: isAuthenticated,
    logout: handleLogout,
    loginLoading: !isAuthenticated && isLoading,
    logoutLoading: isAuthenticated && isLoading,
    isAuthStateLoading: isLoading,
    authError
  };
}
